var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOsWindowsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.029,
    height: 18.821,
    viewBox: "0 0 18.029 18.821",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "OS-Windows-icon",
    d: "M0,34.592l7.389-1.063v7.453H0ZM0,48.229l7.389,1.063v-7.36H0ZM8.2,49.4l9.828,1.416V41.931H8.2Zm0-15.989v7.566h9.828V32L8.2,33.416Z",
    transform: "translate(0 -32)",
    fill: "#848484"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOsWindowsIcon);
export default __webpack_public_path__ + "static/media/OS-Windows-icon.103f50f0d7ca0a71da18d262fd7d902b.svg";
export { ForwardRef as ReactComponent };